import React from 'react';
export function MechanismSection() {
  const molecules = ['Gluten de alta densidad', 'Caseína A1', 'Aceites Oxidados'];
  return <section className="bg-forest text-cream py-24 md:py-32 relative overflow-hidden" data-id="element-53">
      {/* Subtle background pattern/gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(201,168,76,0.1)_0%,transparent_60%)] pointer-events-none" data-id="element-54"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10" data-id="element-55">
        <div className="text-center mb-16" data-id="element-56">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-cream mb-6" data-id="element-57">
            El Protocolo de Sustitución Latina (PSL)
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-58"></div>
        </div>

        <div className="space-y-12 text-lg md:text-xl font-body leading-relaxed max-w-4xl mx-auto" data-id="element-59">
          <p className="text-center text-cream/90" data-id="element-60">
            Es el primer método diseñado específicamente para nuestro sistema
            digestivo. En lugar de prohibir, aprendemos a{' '}
            <strong className="text-gold font-bold text-2xl uppercase tracking-wider" data-id="element-61">
              Sustituir
            </strong>
            .
          </p>

          <div className="bg-cream/5 border border-gold/20 p-8 md:p-12 rounded-sm backdrop-blur-sm" data-id="element-62">
            <p className="mb-8 text-cream/90" data-id="element-63">
              Usamos ingredientes con el mismo perfil de sabor que amas
              —tortillas, sazón, cremosidad— pero eliminamos las moléculas
              inflamatorias que mantienen tu abdomen distendido:
            </p>

            <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-64">
              {molecules.map((molecule, index) => <span key={index} className="inline-flex items-center px-6 py-3 rounded-full text-sm md:text-base font-bold bg-gold/20 text-gold border border-gold/30 shadow-sm" data-id="element-65">
                  {molecule}
                </span>)}
            </div>

            <p className="text-center font-heading text-2xl text-cream italic" data-id="element-66">
              "Es ciencia aplicada a nuestra mesa hispana para que tu cuerpo
              finalmente pueda descansar y repararse."
            </p>
          </div>
        </div>
      </div>
    </section>;
}